import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SteelProducts.css';

const SteelProducts = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);

  const toggleCategory = (index) => {
    if (expandedCategory === index) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(index);
    }
  };

  const steelCategories = [
    {
      title: "TMT BARS - Fe-500 GRADE",
      icon: "🏗️",
      color: "#666666",
      description: "Thermo-Mechanically Treated bars with 500 MPa yield strength",
      image: "/images/products/tmt-bars.jpg",
      specs: [
        "Sizes: 8mm, 10mm, 12mm, 16mm, 20mm, 25mm, 32mm",
        "Length: 12 meters standard",
        "Grade: Fe-500 (Yield Strength: 500 MPa)",
        "Standard: IS 1786",
        "Weight: 0.395 kg/m to 6.31 kg/m"
      ],
      features: [
        "Earthquake resistant - high ductility",
        "Excellent bendability and rebendability",
        "Superior bonding with concrete due to rib pattern",
        "Corrosion resistant",
        "Weldable grade",
        "Thermo-mechanical treatment for strength"
      ],
      applications: "Residential buildings, commercial complexes, bridges, dams, industrial structures"
    },
    {
      title: "TMT BARS - Fe-550 GRADE",
      icon: "🏗️",
      color: "#4d4d4d",
      description: "High strength TMT bars with 550 MPa yield strength for heavy structures",
      image: "/images/products/tmt-550.jpg",
      specs: [
        "Sizes: 8mm, 10mm, 12mm, 16mm, 20mm",
        "Length: 12 meters standard",
        "Grade: Fe-550 (Yield Strength: 550 MPa)",
        "Standard: IS 1786",
        "Higher strength-to-weight ratio"
      ],
      features: [
        "Extra high strength for heavy loads",
        "Superior ductility for seismic zones",
        "Reduced steel consumption (cost-effective)",
        "Excellent fatigue resistance",
        "Perfect for high-rise buildings",
        "Better corrosion resistance"
      ],
      applications: "High-rise buildings, skyscrapers, bridges, flyovers, industrial complexes, power plants"
    },
    {
      title: "STEEL BILLETS",
      icon: "🧱",
      color: "#666666",
      description: "Premium quality steel billets for re-rolling and forging",
      image: "/images/products/steel-billets.jpg",
      specs: [
        "Sizes: 100mm x 100mm, 125mm x 125mm, 130mm x 130mm",
        "Length: 6m / 9m / 12m",
        "Grade: 3SP / 5SP",
        "Standard: ASTM A36 / IS 2830",
        "Weight: Various as per size"
      ],
      features: [
        "Premium quality low carbon steel",
        "Uniform chemical composition",
        "Clean surface - no defects",
        "Controlled cooling process",
        "Excellent re-rolling properties",
        "Consistent mechanical properties"
      ],
      applications: "Re-rolling into TMT bars, forging, manufacturing of structural sections, bright bars"
    },
    {
      title: "DEFORMED BARS",
      icon: "🔨",
      color: "#4d4d4d",
      description: "Ribbed reinforcement bars for concrete construction",
      image: "/images/products/deformed-bars.jpg",
      specs: [
        "Sizes: 10mm, 12mm, 16mm",
        "Length: 12 meters",
        "Grade: Fe-415",
        "Standard: IS 1786",
        "Ribbed pattern for bonding"
      ],
      features: [
        "Ribbed surface for superior concrete bonding",
        "Consistent mechanical properties",
        "Easy to cut and bend",
        "Good weldability",
        "Cost-effective reinforcement",
        "Readily available"
      ],
      applications: "General reinforcement, slabs, beams, columns, foundations, retaining walls"
    },
    {
      title: "PLAIN ROUND BARS",
      icon: "⚪",
      color: "#666666",
      description: "Mild steel round bars for fabrication and general engineering",
      image: "/images/products/round-bars.jpg",
      specs: [
        "Sizes: 6mm to 25mm diameter",
        "Length: 6m / 12m",
        "Grade: Mild Steel / Medium Carbon",
        "Surface: Smooth bright finish",
        "Tight dimensional tolerances"
      ],
      features: [
        "Smooth uniform surface",
        "Excellent machinability",
        "Good weldability",
        "Consistent hardness",
        "Versatile applications",
        "Available in various grades"
      ],
      applications: "Fabrication, shafts, pins, dowels, machined parts, general engineering, grills, gates"
    },
    {
      title: "SQUARE BARS",
      icon: "⬛",
      color: "#4d4d4d",
      description: "Precision rolled square bars for fabrication and structures",
      image: "/images/products/square-bars.jpg",
      specs: [
        "Sizes: 10mm to 20mm",
        "Length: 6 meters",
        "Grade: Mild Steel",
        "Sharp 90° corners",
        "Uniform cross-section"
      ],
      features: [
        "Precision rolled for accuracy",
        "Sharp clean edges",
        "Uniform section throughout",
        "Easy to weld and fabricate",
        "Good strength",
        "Aesthetic finish"
      ],
      applications: "Gates, railings, grills, furniture, frames, brackets, general fabrication"
    },
    {
      title: "FLAT BARS",
      icon: "📏",
      color: "#666666",
      description: "MS flat bars in various widths and thicknesses",
      image: "/images/products/flat-bars.jpg",
      specs: [
        "Widths: 25mm to 50mm",
        "Thickness: 3mm to 6mm",
        "Length: 6 meters",
        "Grade: Mild Steel",
        "Various size combinations"
      ],
      features: [
        "Flat uniform surface",
        "Consistent thickness",
        "Sharp clean edges",
        "Easy to cut and drill",
        "Good weldability",
        "Versatile sizes"
      ],
      applications: "Gates, brackets, clamps, supports, frames, fabrication, structural supports"
    },
    {
      title: "ANGLE BARS",
      icon: "📐",
      color: "#4d4d4d",
      description: "Equal angle sections for structural applications",
      image: "/images/products/angle-bars.jpg",
      specs: [
        "Sizes: 25mm to 65mm",
        "Thickness: 3mm to 6mm",
        "Length: 6 meters",
        "Grade: Mild Steel",
        "Equal leg angles"
      ],
      features: [
        "L-shaped cross-section",
        "Equal leg dimensions",
        "High strength-to-weight ratio",
        "Excellent load bearing",
        "Easy to weld and drill",
        "Standard sizes"
      ],
      applications: "Frames, trusses, supports, racks, towers, structural fabrication, gates"
    },
    {
      title: "CHANNEL SECTIONS",
      icon: "⎕",
      color: "#666666",
      description: "C-channels for structural and industrial applications",
      image: "/images/products/channels.jpg",
      specs: [
        "Sizes: 75mm to 150mm",
        "Length: 6 meters",
        "Grade: Mild Steel",
        "Standard C-sections",
        "Various flange widths"
      ],
      features: [
        "C-shaped cross-section",
        "High load capacity",
        "Excellent structural properties",
        "Easy to connect and weld",
        "Uniform dimensions",
        "Industrial grade"
      ],
      applications: "Purlins, girts, frames, supports, industrial sheds, mezzanine floors, truck bodies"
    },
    {
      title: "I-BEAMS (ISMB)",
      icon: "📊",
      color: "#4d4d4d",
      description: "Indian Standard Medium Weight Beams for heavy structures",
      image: "/images/products/ibeams.jpg",
      specs: [
        "Sizes: ISMB 100 to ISMB 250",
        "Length: 6m / 9m / 12m",
        "Grade: Mild Steel",
        "Standard: IS 808",
        "Various sections available"
      ],
      features: [
        "I-shaped cross-section",
        "Superior load bearing capacity",
        "Excellent for bending loads",
        "Standardized dimensions",
        "High strength-to-weight ratio",
        "Industrial standard"
      ],
      applications: "Building frames, bridges, gantry girders, columns, heavy structures, industrial sheds"
    },
    {
      title: "WIRE RODS",
      icon: "🧵",
      color: "#666666",
      description: "Hot rolled wire rods for wire drawing and mesh manufacturing",
      image: "/images/products/wire-rods.jpg",
      specs: [
        "Diameters: 5.5mm, 6.5mm, 8mm",
        "Form: Coils of 1 ton",
        "Grade: Low Carbon / High Carbon",
        "Clean surface finish",
        "Uniform properties"
      ],
      features: [
        "Hot rolled quality",
        "Excellent drawability",
        "Consistent mechanical properties",
        "Clean surface - minimal scale",
        "Uniform cross-section",
        "Coiled for easy handling"
      ],
      applications: "Wire drawing, nails, wire mesh, fencing, binding wire, cold heading quality"
    }
  ];

  return (
    <div className="products-page steel-products-page">
      <div className="container">
        <h1 className="page-title">Masai Rolling Mills - Products</h1>
        <p className="page-subtitle">Quality Steel for Construction & Industry</p>
        
        <div className="intro-banner steel-banner">
          <div className="banner-content">
            <h2>Premium Steel Manufacturer in Kenya</h2>
            <p>Recycling scrap steel for sustainable construction - TMT bars, billets & structural sections</p>
            <div className="banner-stats">
              <span>📍 Kitengela, Off Mombasa Road</span>
              <span>📞 0738 200500</span>
              <span>✅ KEBS Approved</span>
            </div>
          </div>
        </div>
        
        <div className="products-showcase steel-showcase">
          {steelCategories.map((category, index) => (
            <div key={index} className={`product-showcase-card steel-showcase-card ${expandedCategory === index ? 'expanded' : ''}`}>
              <div className="product-showcase-header" onClick={() => toggleCategory(index)}>
                <div className="product-icon" style={{ background: category.color }}>{category.icon}</div>
                <div className="product-header-info">
                  <h2>{category.title}</h2>
                  <p className="product-description">{category.description}</p>
                </div>
                <div className="expand-icon">
                  {expandedCategory === index ? '−' : '+'}
                </div>
              </div>
              
              {expandedCategory === index && (
                <div className="product-expanded-content">
                  <div className="product-specs">
                    <h3>Specifications</h3>
                    <ul>
                      {category.specs.map((spec, i) => (
                        <li key={i}>{spec}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="product-features">
                    <h3>Key Features</h3>
                    <ul>
                      {category.features.map((feature, i) => (
                        <li key={i}>✓ {feature}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="product-applications">
                    <h3>Applications</h3>
                    <p>{category.applications}</p>
                  </div>
                  
                  <div className="product-actions">
                    <Link to="/steel-catalogue" className="btn btn-primary">View Full Catalogue</Link>
                    <Link to="/contact" className="btn btn-secondary">Request Quote</Link>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="certification-section">
          <h2>Quality Certifications</h2>
          <div className="cert-grid">
            <div className="cert-item">
              <span className="cert-icon">🏅</span>
              <h4>ISO 9001:2015</h4>
              <p>Quality Management System</p>
            </div>
            <div className="cert-item">
              <span className="cert-icon">✓</span>
              <h4>KEBS Approved</h4>
              <p>Kenya Bureau of Standards</p>
            </div>
            <div className="cert-item">
              <span className="cert-icon">🔬</span>
              <h4>In-house Lab</h4>
              <p>Regular quality testing</p>
            </div>
          </div>
        </div>

        <div className="capacity-section">
          <h2>Manufacturing Capacity</h2>
          <div className="capacity-grid">
            <div className="capacity-card">
              <h3>50,000+</h3>
              <p>Tons per Year</p>
            </div>
            <div className="capacity-card">
              <h3>100%</h3>
              <p>Recycled Scrap Steel</p>
            </div>
            <div className="capacity-card">
              <h3>24/7</h3>
              <p>Production</p>
            </div>
          </div>
        </div>

        <div className="cta-section steel-cta-section">
          <h2>Need Bulk Quantities?</h2>
          <p>Contact us for special pricing on large orders</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Get Quote</Link>
            <a href="tel:0738200500" className="btn btn-secondary">Call 0738 200500</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SteelProducts;